
<template>
  <div>

     <md-table>
          <md-table-row>
              <md-table-head md-numeric>#</md-table-head>
              <md-table-head>Name</md-table-head>
              <md-table-head>Ambiente</md-table-head>
              <md-table-head></md-table-head>
          </md-table-row>

          <md-table-row v-for="item in items" :key="item.id">
              <md-table-cell md-numeric>{{ item.id }}</md-table-cell>
              <md-table-cell>{{ item.name }}</md-table-cell>
              <md-table-cell>{{ item.amb }}</md-table-cell>
              <md-table-cell>
                    <md-button  @click="setTokenCompany(item.id)" class="md-raised"> Ver empresa </md-button>
                    <md-button :to="{name:'AdmCompanyForm',params:{id:item.id}}" class="md-raised md-primary"> Editar </md-button>
                    <md-button  @click="remove(item.id)" class="md-raised md-accent"> Excluir </md-button>
              </md-table-cell>
      </md-table-row>
    </md-table>          
  </div>
</template>

<script>

 

 
export default {
   
  props:{
      items: Array
  },
  methods:{
    remove(id){
      
      if(!confirm("Deseja excluir?")){
        return false
      }
      this.$emit("remove", id)      
    }, 
    setTokenCompany(id){
      this.$store.dispatch("AdmCompany/setToken",id)
    }
  }
};
</script>
